import { useState } from 'react';

import styles from './ContactUs.module.css';
import telegram from '../../../images/telegram.png';
import phone from '../../../images/phone.png';
import axios from 'axios';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
  });

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    console.log('Form Submitted', formData);
    const message = `<div>
      <p>Name: ${formData.name}</p>
      <p>Email: ${formData.email}</p>
      <p>Phone: ${formData.phone}</p>
      <p>Message: ${formData.message}</p>
    </div>`;
    const url =
      'https://qf619qasm2.execute-api.us-east-2.amazonaws.com/dev/sendMail';
    axios.post(url, {
      recipient: 'dreamonelove.official@gmail.com',
      topic: 'New message from Artemida Studio',
      message: message,
    });
    setFormData({
      name: '',
      phone: '',
      email: '',
      message: '',
    });
  };

  return (
    <>
      <div className={styles.contactContainer} id="contact">
        <h1>LET'S DISCUSS YOUR PROJECT</h1>
        <div className={styles.contactFormContainer}>
          <div className={styles.contactInfo}>
            <p>Warsaw, Poland</p>
            <p>Rolna str. 191/193</p>
            <p>02-729</p>
            <p>
              <a href="tel:+48500815139" className={styles.link}>
                +48 500 815 139
              </a>
            </p>
            <p>
              <a
                href="mailto:dreamonelove.official@gmail.com"
                className={styles.link}
              >
                dreamonelove.official@gmail.com
              </a>
            </p>
            <div className={styles.icons}>
              <a
                href="https://t.me/ikharatin"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={telegram}
                  alt="Telegram"
                  loading="lazy"
                  className={styles.icon}
                />
              </a>
              <a href="tel:+48500815139">
                <img
                  src={phone}
                  alt="Phone"
                  loading="lazy"
                  className={styles.icon}
                />
              </a>
            </div>
          </div>
          <form className={styles.contactForm} onSubmit={handleSubmit}>
            <div className={styles.gradientContainer}>
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
                className={styles.input}
              />
            </div>
            <div className={styles.gradientContainer}>
              <input
                type="text"
                name="phone"
                placeholder="Phone"
                value={formData.phone}
                onChange={handleChange}
                required
                className={styles.input}
              />
            </div>
            <div className={styles.gradientContainer}>
              <input
                type="text"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
                className={styles.input}
              />
            </div>
            <div className={styles.gradientContainer}>
              <textarea
                name="message"
                placeholder="Tell us about your project"
                value={formData.message}
                onChange={handleChange}
                required
                className={styles.textarea}
              />
            </div>

            <button type="submit" className={styles.contactUs}>
              Send
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
